import { makeAutoObservable, configure } from "mobx"
import {  getStockDetailDataSSE } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"
configure({ useProxies: "ifavailable" })

class Store {
  constructor() {
    if (getPageType() == PageType.沪深京指数 || getPageType() == PageType.choice指数) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null
  

  init() {
    this.getData()
  }

  getData() {
    getStockDetailDataSSE(window.quotedata.quotecode, "f43,f44,f45,f46,f47,f48,f59,f60,f113,f114,f115,f116,f117,f135,f136,f137,f138,f139,f140,f141,f142,f143,f144,f145,f146,f147,f148,f149,f140,f143,f146,f149,f152,f164,f168,f169,f170,f171,f177,f178,f292,f296,f734", (data:any)=>{
      this.setStockDetail(data)
    })
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
